<template>
  <b-modal
    :active="true"
    :can-cancel="['escape', 'x', 'outside']"
    @close="onClose"
    width="50%"
  >
    <div class="content">
      <div class="header">
        <h1 class="title">Edit Phase</h1>
      </div>

      <div class="columns">
        <div class="column">
          <b-field label="Phase Name*">
            <b-input
              v-model="phaseName"
              required
              placeholder="Enter phase name..."
            />
          </b-field>
        </div>
      </div>

      <div class="report-sections">
        <p class="report-sections-label">Report Sections</p>
        <div class="sections-grid">
          <b-checkbox
            v-for="section in REPORT_SECTIONS"
            :key="section.key"
            v-model="selectedSections"
            :native-value="section.key"
          >
            {{ section.label }}
          </b-checkbox>
        </div>
      </div>

      <footer class="footer-buttons">
        <b-button label="Cancel" @click="onClose" type="is-danger" />
        <b-button label="Save" @click="onSave" type="is-success" />
      </footer>
    </div>
  </b-modal>
</template>

<script>
const REPORT_SECTIONS = [
  { key: 'deviationReport', label: 'Deviation Report' },
  { key: 'projectInfo', label: 'Project Info' },
  { key: 'summaryText', label: 'Executive Summary' },
  { key: 'revisionHistory', label: 'Revision History' },
  { key: 'projectContacts', label: 'Project Contacts' },
  { key: 'tableOfContents', label: 'Table of Contents' },
  { key: 'generalInformation', label: 'General Information' },
  { key: 'referenceImage', label: 'Reference Image' },
  { key: 'repairAssessment', label: 'Component Overview' },
  { key: 'findingsRAT', label: 'Findings (RAT)' },
  {
    key: 'factFindingField',
    label: 'Work performed for Fact Finding Inspection',
  },
  { key: 'workPerformedRepairField', label: 'Work performed for Repair' },
  {
    key: 'repairsRecommendationsUpgradesField',
    label: 'Repairs Not Completed, Recommendations & Upgrades',
  },
  { key: 'recommendedWorkRepair', label: 'Recommended Work for Repair' },
  { key: 'newParts', label: 'New Parts' },
  { key: 'inspectionTasks', label: 'Phase Tasks' },
  { key: 'appendix', label: 'Appendix' },
];

export default {
  name: 'edit-job-phase-modal',

  props: {
    phase: {
      type: Object,
      required: true,
    },
  },

  data() {
    const allKeys = REPORT_SECTIONS.map((s) => s.key);
    return {
      REPORT_SECTIONS,
      phaseName: this.phase.name,
      selectedSections:
        this.phase.reportSections && this.phase.reportSections.length > 0
          ? [...this.phase.reportSections]
          : [...allKeys],
    };
  },

  methods: {
    onClose() {
      this.$emit('close');
    },

    onSave() {
      if (!this.phaseName || !this.phaseName.trim()) {
        this.$buefy.toast.open({
          message: 'Please enter a phase name.',
          type: 'is-danger',
          duration: 5000,
        });
        return;
      }
      this.$emit('onSave', {
        name: this.phaseName.trim(),
        reportSections: [...this.selectedSections],
      });
    },
  },
};
</script>

<style scoped>
.content {
  background: white;
  border-radius: 10px;
  padding: 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.header {
  display: flex;
  justify-content: space-between;
}

.report-sections {
  margin-top: 10px;
}

.report-sections-label {
  font-weight: bold;
  margin-bottom: 8px;
}

.sections-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 16px;
}

.footer-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}
</style>
